import request from '@/utils/request'

const XIN_AO_TRAINING = '/xinaotraining'

export function problemList(params) {
    return request({
        url: XIN_AO_TRAINING + '/problem_list',
        method: 'get',
        params
    })
}

export function problemInfo(params) {
    return request({
        url: XIN_AO_TRAINING + '/problem_info',
        method: 'get',
        params
    })
}

export function problemTag(params) {
    return request({
        url: XIN_AO_TRAINING + '/problem_tag',
        method: 'get',
        params
    })
}

export function userResult(params) {
    return request({
        url: XIN_AO_TRAINING + '/user_result',
        method: 'get',
				isLoading: false,
        params
    })
}

export function userResultRecord(params) {
    return request({
        url: XIN_AO_TRAINING + '/user_result_record',
        method: 'get',
        params
    })
}

export function submitAnswer(data) {
    return request({
        url: XIN_AO_TRAINING + '/submit_answer',
        method: 'post',
        data
    })
}

export function downloadTestPoint(data) {
    return request({
        url: XIN_AO_TRAINING + '/download_test_point',
        method: 'post',
        responseType: 'arraybuffer',
        data
    })
}

export function downloadTestPointCount(params) {
    return request({
        url: XIN_AO_TRAINING + '/download_test_point_count',
        method: 'get',
        params
    })
}
